// Enquanto o ativo esta com buffer critico os vizinhos pausam o loading.
// Limiares diferentes (histerese) evitam liga-desliga a cada segmento.
const CRITICAL_BELOW_S = 4;
const HEALTHY_ABOVE_S = 8;

// Watchdog: se o ativo para de reportar (erro, background, destruido), os
// vizinhos nao podem ficar com stopLoad para sempre.
const REPORT_SILENCE_MS = 6000;

type PipeState = 'critical' | 'healthy';

const pipeState = ref<PipeState>('healthy');
let silenceTimer: ReturnType<typeof setTimeout> | null = null;

function armSilenceWatchdog(): void {
	if (silenceTimer !== null) clearTimeout(silenceTimer);
	silenceTimer = setTimeout(() => {
		silenceTimer = null;
		pipeState.value = 'healthy';
	}, REPORT_SILENCE_MS);
}

export function useVideoPipeState(): Readonly<Ref<PipeState>> {
	return readonly(pipeState);
}

export function reportActiveBuffer(
	aheadSeconds: number,
	fullyBuffered: boolean
): void {
	if (fullyBuffered || aheadSeconds >= HEALTHY_ABOVE_S) {
		pipeState.value = 'healthy';
	} else if (aheadSeconds < CRITICAL_BELOW_S) {
		pipeState.value = 'critical';
	}
	// entre os limiares: mantem o estado atual (histerese)
	if (pipeState.value === 'critical') {
		armSilenceWatchdog();
	} else if (silenceTimer !== null) {
		clearTimeout(silenceTimer);
		silenceTimer = null;
	}
}

/** Troca de video ativo: o novo comeca sem credito de folga. */
export function resetPipeState(): void {
	pipeState.value = 'critical';
	armSilenceWatchdog();
}

/** O ativo desistiu: nao pode continuar segurando o cano dos vizinhos. */
export function releasePipe(): void {
	if (silenceTimer !== null) {
		clearTimeout(silenceTimer);
		silenceTimer = null;
	}
	pipeState.value = 'healthy';
}
